import { render, staticRenderFns } from "./PackingStructure.vue?vue&type=template&id=be93b36e&scoped=true&"
import script from "./PackingStructure.vue?vue&type=script&lang=js&"
export * from "./PackingStructure.vue?vue&type=script&lang=js&"
import style0 from "./PackingStructure.vue?vue&type=style&index=0&id=be93b36e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be93b36e",
  null
  
)

export default component.exports